var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { IndexModel } from "../Support/IndexModel";
var OrderItemIndex = (function (_super) {
    __extends(OrderItemIndex, _super);
    function OrderItemIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpoint = "order/history";
        _this.filters = {
            query: null,
            status: null,
            start_date: null,
            end_date: null
        };
        return _this;
    }
    OrderItemIndex.prototype.getData = function () {
        return _super.prototype.getData.call(this);
    };
    OrderItemIndex.prototype.resetFilters = function () {
        this.filters = {
            query: null,
            status: null,
            start_date: null,
            end_date: null
        };
        return _super.prototype.resetFilters.call(this);
    };
    return OrderItemIndex;
}(IndexModel));
export { OrderItemIndex };
